var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormContext, initialState, reducer } from '../../common/context/context';
import { LocalStorageKeys } from '../../common/enums/local-storage-keys';
import { ApiI18 } from '../../network/api';
import { baseImgURL } from '../../network/api-config';
import { FlexSpaceBetweenContainer } from '../../styles/generalStyles';
import { MainTextStyle } from '../../styles/variables/text.styles';
import DropdownInput from '../_common/dropdown/dropdown';
import Input from '../_common/input/input';
import { LangHelper } from '../_common/lang/helper';
import LangMessage from '../_common/lang/message';
import { PageLayout } from '../_common/pageLayout/pageLayout';
import ScrollbarWrapper from '../_common/scrollbar/scrollbarWrapper';
import { BdpPhotoWithoutSelected } from '../bdpPhoto/bdpPhoto';
import { CarouselBdps } from '../carouselBdps/carouselBdps';
var isCustomer = localStorage.getItem('role') === 'customer';
export var PageBackgrops = function () {
    var _a = React.useReducer(reducer, initialState), state = _a[0], dispatch = _a[1];
    var navigate = useNavigate();
    var _b = useState(''), searchValue = _b[0], setSearchValue = _b[1];
    var _c = useState([]), myBackdrops = _c[0], setMyBackdropList = _c[1];
    var _d = useState([]), myBackdropOrders = _d[0], setMyBackdropOrderList = _d[1];
    var _e = useState(false), showCarouselBdps = _e[0], setShowCarouselBdps = _e[1];
    var filterBackdropsOptions = __spreadArray([
        { defaultValue: "By name", text: "gadArt.ByName" },
        { defaultValue: "By updated date", text: "gadArt.ByUpdatedDate" },
        { defaultValue: "By creation date", text: "gadArt.ByCreationDate" }
    ], (isCustomer ? [{ defaultValue: "By tag", text: "gadArt.ByTag" }]
        : [
            { defaultValue: "Standard", text: "gadArt.Standard" },
            { defaultValue: "Premium", text: "gadArt.Premium" },
            { defaultValue: "Premium+", text: "gadArt.Premium+" }
        ]), true);
    var _f = useState(filterBackdropsOptions[1].text), selectedfilterBackdrops = _f[0], setSelectedFilterBackdrops = _f[1];
    var _g = useState({ index: 0, name: undefined, showroom: null, src: null }), selectedImageInCarousel = _g[0], setSelectedImageInCarousel = _g[1];
    var selectedLang = localStorage.getItem(LocalStorageKeys.SELECTED_LANG);
    var translatedSelectedFilterBackdrops = LangHelper.getLangMessageValue(selectedfilterBackdrops, selectedLang, selectedfilterBackdrops);
    var loadData = useCallback(function (page) {
        var sort = { updatedAt: -1 };
        switch (selectedfilterBackdrops) {
            case "gadArt.ByName":
                sort = { name: 1 };
                break;
            case "gadArt.ByCreationDate":
                sort = { createdAt: -1 };
                break;
            case "gadArt.ByTag":
                sort = { tag: -1 };
                break;
            default:
                sort = { updatedAt: -1 };
        }
        if (isCustomer) {
            ApiI18.getMyBackdrops({ search: searchValue, sort: sort }).then(function (res) {
                var _a;
                if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.payload) {
                    setMyBackdropList(res.data.payload);
                }
            });
            ApiI18.getMyBackdropOrders({}).then(function (res) {
                var _a;
                if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.payload) {
                    var backdropOrders = res.data.payload.map(function (it) {
                        if (it.backdropWithLogoStatus !== 'READY') {
                            var bdp = {
                                _id: it.initialBackdropId,
                                backdropNumber: it.backdropNumber,
                                backdropWithLogoStatus: it.backdropWithLogoStatus,
                                createdAt: it.createdAt,
                                image: it.initialBackdropImage,
                                logos: it.logos,
                                name: it.backdropWithLogoStatus,
                                tag: []
                            };
                            return bdp;
                        }
                    });
                    setMyBackdropOrderList(backdropOrders);
                }
            });
        }
        else {
            ApiI18.getListBackdrops({ limit: 35, page: page, search: searchValue, sort: sort }).then(function (res) {
                var _a;
                if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.payload) {
                    setMyBackdropList(res.data.payload || (function (prevBackdrops) { return __spreadArray(__spreadArray([], prevBackdrops, true), res.data.payload, true); }));
                }
            });
        }
    }, [searchValue, selectedfilterBackdrops]);
    var loadMoreData = function () {
        var nextPage = Math.ceil(myBackdrops.length / 35) + 1;
        loadData(nextPage);
    };
    useEffect(function () {
        loadData(1);
    }, [loadData]);
    var onClickBackButton = function () {
        navigate(-1);
    };
    var searchBackdrop = function (e) {
        setSearchValue(e.target.value.toLowerCase().replace('  ', ' '));
    };
    var handleSelectedilterBackdrops = function (filterBackdrops) {
        setSelectedFilterBackdrops(filterBackdrops);
        var sortedBackdrops = [];
        switch (filterBackdrops) {
            case "gadArt.Standard":
                sortedBackdrops = myBackdrops.filter(function (bdp) { return bdp.tag.includes("Standard"); });
                break;
            case "gadArt.Premium":
                sortedBackdrops = myBackdrops.filter(function (bdp) { return bdp.tag.includes("Premium"); });
                break;
            case "gadArt.Premium+":
                sortedBackdrops = myBackdrops.filter(function (bdp) { return bdp.tag.includes("Premium+"); });
                break;
            default:
                sortedBackdrops = myBackdrops;
        }
        setMyBackdropList(sortedBackdrops);
    };
    var handleImageClick = function (imageSrc, imageName, showroom, index) {
        setSelectedImageInCarousel({ index: index, name: imageName, showroom: showroom, src: imageSrc });
    };
    var myAllBackdrops = myBackdropOrders.concat(myBackdrops).filter(function (it) { return !!it; });
    return (_jsx(FormContext.Provider, __assign({ value: { dispatch: dispatch, state: state } }, { children: _jsxs(PageLayout, __assign({ title: 'Backdrops', onClickBackButton: onClickBackButton }, { children: [_jsxs(FlexSpaceBetweenContainer, __assign({ "$gap": '20px' }, { children: [_jsx(Input, { placeholder: "CustDashboard.searchBackdrop", required: false, name: 'Search backdrops', onChange: searchBackdrop, value: searchValue, handleClearInput: function () { return setSearchValue(''); }, inputWidth: "100%", widthFull: '100%' }), _jsx(DropdownInput, { options: filterBackdropsOptions, inputValue: translatedSelectedFilterBackdrops, placeholder: 'Uploaded newest', setInputValue: function () { return setSearchValue(''); }, ddWidth: '230px', widthFull: '230px', showArrow: true, onSelect: handleSelectedilterBackdrops })] })), _jsx("div", __assign({ style: { paddingTop: '40px' } }, { children: myAllBackdrops.filter(function (bdp) { var _a; return (_a = bdp.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue); }).length ? (_jsx(ScrollbarWrapper, __assign({ isFlexDisplay: false, idContent: 'myBackdrops', direction: 'vertical', height: '520px', heightDesktop: "calc(100vh - 280px)", gabContent: '20px', loadMore: loadMoreData, hasMore: true }, { children: myAllBackdrops
                            .filter(function (bdp) { var _a; return (_a = bdp.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue); })
                            .map(function (bdp, index) {
                            var _a;
                            return (_jsx(BdpPhotoWithoutSelected, __assign({ sizePhoto: 'medium', showLogo: !!((_a = bdp.logos) === null || _a === void 0 ? void 0 : _a.length) }, { baseImgURL: baseImgURL, bdp: bdp, bdpImage: bdp.image, index: index, logos: bdp.logos }, { onClick: function () { setShowCarouselBdps(true); handleImageClick("".concat(baseImgURL, "/").concat(bdp.image), bdp.name, bdp.showroom, index); } }), index));
                        }) }))) : (_jsx(MainTextStyle, { children: _jsx(LangMessage, { msgKey: 'form.noResult' }) })) })), showCarouselBdps && (_jsx(CarouselBdps, { isCustomer: isCustomer, myBackdrops: myAllBackdrops ? myAllBackdrops.filter(function (bdp) { var _a; return (_a = bdp.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue); }) : [], lang: state.lang, showCarouselBdps: showCarouselBdps, setShowCarouselBdps: setShowCarouselBdps, thumbs: myAllBackdrops ? myAllBackdrops.filter(function (bdp) { var _a; return (_a = bdp.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue); }) : [], selectedImageSrc: selectedImageInCarousel.src ? [selectedImageInCarousel.src] : [], selectedImageIndex: selectedImageInCarousel.index ? selectedImageInCarousel.index : 0 }))] })) })));
};
